export const environment = {
  production: true,
  apiURL: "aHR0cHM6Ly9wcm9kLWp1YW5wYWJsby10bXMtYXV0aC5henVyZXdlYnNpdGVzLm5ldC9hcGkvdjEv",
  ambiente: 'Prod - ',
  domain: "",
  encryptionType: 'AES-ENC',
  aesKey: 'NjhEQ0U1RkVFQzcwMUY5ODYxOUYxQURDRDE0NzE5Njg=',
  transformActive: true,
  // Configuración de WebSocket
  websocket: {
    enabled: true, // Habilitado para producción (plantilla configurable)
    host: '',
    port: '443', // Puerto HTTPS estándar
    protocol: 'wss' // WSS para HTTPS
  }
};

